import { SaleOrderItemsMergeData } from '../..';
import { CurrencyFormatter } from '../../../../../utilities';

export class FakeSaleOrderItemsMergeData extends SaleOrderItemsMergeData {
    constructor() {
        super();

        this.items = [
            {
                name: 'MANUAL 1',
                description: 'Quisque cursus vel ex eu imperdiet. Sed porta accumsan turpis. Aliquam elementum rutrum ipsum id congue.',
                note: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
                quantity: '10',
                codeUoM: 'EACH',
                location: 'Warehouse 1',
                sellPrice: CurrencyFormatter.formatCurrency(300, 2),
                saleTaxRate: "GTS On Income",

                totalSellEx: CurrencyFormatter.formatCurrency(250, 2),
                totalSellInc: CurrencyFormatter.formatCurrency(250, 2),
                totalTax: CurrencyFormatter.formatCurrency(25, 2),
            },
            {
                name: 'MANUAL 2',
                description: 'Quisque cursus vel ex eu imperdiet. Sed porta accumsan turpis. Aliquam elementum rutrum ipsum id congue.',
                note: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
                quantity: '20',
                codeUoM: 'EACH',
                location: 'Warehouse 1',
                sellPrice: CurrencyFormatter.formatCurrency(300, 2),
                saleTaxRate: "GTS On Income",

                totalSellEx: CurrencyFormatter.formatCurrency(250, 2),
                totalSellInc: CurrencyFormatter.formatCurrency(250, 2),
                totalTax: CurrencyFormatter.formatCurrency(25, 2),
            },
        ];
    }
}